import { useRef } from 'react';

const CLOSE_MS = 280;
const EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

export function useDrawerDrag(onClose) {
  const modalRef = useRef(null);
  const startY = useRef(null);
  const currentY = useRef(0);
  const closing = useRef(false);

  // Dragged far enough: keep sliding the drawer off-screen (and fade the
  // overlay with it) before unmounting, so the dismissal reads as one
  // continuous gesture instead of the drawer blinking out.
  function slideOutAndClose() {
    const el = modalRef.current;
    if (!el) {
      onClose();
      return;
    }
    closing.current = true;
    const overlay = el.parentElement;
    el.style.transition = `transform ${CLOSE_MS}ms ${EASE}`;
    el.style.transform = 'translateY(100%)';
    if (overlay) {
      overlay.style.transition = `opacity ${CLOSE_MS}ms ease`;
      overlay.style.opacity = '0';
      overlay.style.pointerEvents = 'none';
    }
    setTimeout(() => {
      closing.current = false;
      onClose();
    }, CLOSE_MS);
  }

  function onTouchStart(e) {
    if (closing.current) return;
    startY.current = e.touches[0].clientY;
    currentY.current = 0;
  }

  function onTouchMove(e) {
    if (closing.current || startY.current === null) return;
    const dy = e.touches[0].clientY - startY.current;
    if (dy > 0 && modalRef.current) {
      currentY.current = dy;
      modalRef.current.style.transition = 'none';
      modalRef.current.style.transform = `translateY(${dy}px)`;
    }
  }

  function onTouchEnd() {
    if (closing.current) return;
    if (currentY.current > 80) {
      slideOutAndClose();
    } else if (modalRef.current) {
      modalRef.current.style.transition = `transform ${CLOSE_MS}ms ${EASE}`;
      modalRef.current.style.transform = '';
      const el = modalRef.current;
      setTimeout(() => { if (el) el.style.transition = ''; }, CLOSE_MS);
    }
    startY.current = null;
    currentY.current = 0;
  }

  return {
    modalRef,
    // Same animated dismissal as the drag gesture, for backdrop taps etc.
    close: slideOutAndClose,
    dragHandleProps: { onTouchStart, onTouchMove, onTouchEnd, onTouchCancel: onTouchEnd },
  };
}
